import React, { Component } from 'react'
import ProposalSectionLine from './ProposalSectionLine'
// import ProposalSectionLineChild from './ProposalSectionLineChild'

class ProposalSectionLines extends Component {
  renderItem = (item, index) => {
    const {
      proposalItems,
      sectionId,
      handleItemChange,
      sectionIndex,
      moveItemRight,
      moveItemLeft,
      moveItemUp,
      moveItemDown,
      handleDeleteItem
    } = this.props
    return (
      <ol key={index} style={{ listStyleType: 'none' }}>
        <ProposalSectionLine
          key={`s${sectionId.toString()}-i${index}`}
          item={item}
          sectionIndex={sectionIndex}
          handleItemChange={handleItemChange}
          index={index}
          disableMoveItemUp={index === 0}
          disableMoveItemDown={proposalItems.length - 1 === index}
          moveItemRight={moveItemRight}
          moveItemLeft={moveItemLeft}
          moveItemUp={moveItemUp}
          moveItemDown={moveItemDown}
          handleDeleteItem={handleDeleteItem}
        />
        {item.items && item.items.map(this.renderItem)}
      </ol>
    )
  }

  render() {
    const { proposalItems } = this.props

    if (proposalItems && Object.keys(proposalItems).length) {
      return proposalItems.map(this.renderItem)
    } else {
      return <ol>No items</ol>
    }
  }
}

export default ProposalSectionLines



// WEBPACK FOOTER //
// ./src/components/ProposalSectionLines.js